import sanitize, { defaults } from 'sanitize-html';
import meta from './meta';
import env from '../config/env';

export { meta };

export function sanitizeHtml(html) {
  return sanitize(html, {
    allowedTags: [
      ...defaults.allowedTags,
      'img', 'iframe',
    ],
    allowedAttributes: {
      '*': ['style'],
      a: ['href', 'name', 'target'],
      img: ['src', 'width', 'height'],
      iframe: ['src', 'width', 'height', 'frameborder', 'allowfullscreen'],
    },
    allowedStyles: {
      '*': {
        color: [
          /^#(0x)?[0-9a-f]+$/i,
          /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
        ],
        'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
        width: [/^\d+(\.\d+)?(px|%)$/],
        height: [/^\d+(\.\d+)?(px|%)$/],

      },
    },
  });
}

export function resolvePath(...segments) {
  const { origin, pathname } = window.location;

  let url = new URL(`${origin}${pathname.replace(/\/$/, '')}/`);

  segments.forEach((s) => {
    url = new URL(s, url);
  });

  return url.pathname.replace(/\/$/, '');
}

export function reduceLng(value) {
  return env.lngs.reduce((obj, l, i) => ({
    ...obj,
    [l]: typeof value === 'function'
      ? value(l, env.lngLabels[i])
      : value,
  }), {});
}

export function mapLng(value) {
  return env.lngs.map((l, i) => (
    typeof value === 'function'
      ? value(l, env.lngLabels[i])
      : value
  ));
}

export function numToLetter(num, uppercase = false) {
  const l = String.fromCharCode(97 + parseInt(num, 10));

  return uppercase ? l.toUpperCase() : l;
}
